import type { PluginManifest } from '@/lib/plugin-registry';
import type { PluginWiring } from './types';

export function buildPluginWirings(
  plugin: PluginManifest,
  allManifests: PluginManifest[],
): PluginWiring[] {
  const wirings: PluginWiring[] = [];

  if (plugin.server?.webhookProvider) {
    const provider = plugin.server.webhookProvider;
    const receiverMap = new Map<string, Set<string>>();
    for (const m of allManifests) {
      if (m.enabled === false || !m.server?.webhookReceivers) continue;
      for (const r of m.server.webhookReceivers) {
        if (r.source === provider.source) {
          const existing = receiverMap.get(m.name);
          if (existing) {
            r.events.forEach((e) => existing.add(e));
          } else {
            receiverMap.set(m.name, new Set(r.events));
          }
        }
      }
    }
    const receivers = [...receiverMap].map(([pluginName, events]) => ({
      pluginName,
      events: [...events],
    }));
    wirings.push({
      role: 'provider',
      source: provider.source,
      route: provider.route,
      events: provider.events,
      receivers,
    });
  }

  if (plugin.server?.webhookReceivers) {
    const receiversBySource = new Map<string, Set<string>>();
    for (const r of plugin.server.webhookReceivers) {
      const existing = receiversBySource.get(r.source);
      if (existing) {
        r.events.forEach((e) => existing.add(e));
      } else {
        receiversBySource.set(r.source, new Set(r.events));
      }
    }
    for (const [source, subscribedSet] of receiversBySource) {
      const providerManifest = allManifests.find(
        (m) => m.server?.webhookProvider?.source === source,
      );
      const providerEvents = providerManifest?.server?.webhookProvider?.events ?? [];
      wirings.push({
        role: 'receiver',
        source,
        events: providerEvents.map((e) => ({
          ...e,
          _subscribed: subscribedSet.has(e.event),
        })) as Array<{ event: string; description?: string }>,
        receivers: [],
        providerPluginName: providerManifest?.name,
      });
    }
  }

  return wirings;
}
